export const WEBSOCKET_SHAREDB_HOST =
  process.env.REACT_APP_WEBSOCKET_SHAREDB_HOST || window.location.host;

export const SHAREDB_COLLECTION = 'worksheets';
